import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Utils, translate } from 'versafleet-core';

class MeasurementViewItem extends React.Component {
  _onEdit() {
    this.props.onEdit();
  }

  _onDelete() {
    this.props.onDelete();
  }

  _showCustomId() {
    const { data, versadriveSetting } = this.props;
    const hasCustomID = !Utils.Helper.isNullOrUndefined(data.custom_item_id);
    return hasCustomID && (
      versadriveSetting.delivery_job_scan_enabled
      || versadriveSetting.delivery_task_scan_enabled
      || versadriveSetting.pickup_job_scan_enabled
      || versadriveSetting.pickup_task_scan_enabled
    );
  }

  render() {
    const {
      data, account, index, strings,
    } = this.props;

    // Should render altogether or not
    const hasWeight = (!Utils.Helper.isNullOrUndefined(data.weight));
    const hasDimensions = (
      !Utils.Helper.isNullOrUndefined(data.volume_length)
        && !Utils.Helper.isNullOrUndefined(data.volume_height)
        && !Utils.Helper.isNullOrUndefined(data.volume_width)
    );
    const hasVolume = !Utils.Helper.isNullOrUndefined(data.volume);

    // Calculate the volume
    const volume = (
      Utils.Helper.isNullOrUndefined(this.props.data.volume)
        ? data.volume_length * data.volume_width * data.volume_height : data.volume
    );

    const measurementUnits = Utils.Helper.getMeasurementUnits();
    const volumeUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].volumeUnit : 'in³';
    const dimensionUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].dimensionUnit : 'in';
    const weightUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].weightUnit : 'lb';
    const shippingFactorUnit = !Utils.Helper.isNullOrUndefined(account.unit_system)
      ? measurementUnits[account.unit_system].shippingFactorUnit : 'in³/lb';

    const renderedLength = Utils.Helper.isNullOrUndefined(data.volume_length) ? '-' : data.volume_length;
    const renderedWidth = Utils.Helper.isNullOrUndefined(data.volume_width) ? '-' : data.volume_width;
    const renderedHeight = Utils.Helper.isNullOrUndefined(data.volume_height) ? '-' : data.volume_height;

    return (
      <div className="vf-measurement-view-item">

        <div className="vf-measurement-view-item__index">
          {`${index + 1}.`}
        </div>

        <div className="vf-measurement-view-item__content">
          <div className="vf-measurement-view-item__content__quantity">
            <span>{data.quantity}</span>
            <span className="vf-measurement-view-item__content__multiplier">x</span>
            <span>{data.quantity_unit}</span>
            {this._showCustomId() && (
              <span className="vf-measurement-view-item__content__custom_id">{data.custom_item_id}</span>
            )}
          </div>
          <div className="vf-measurement-view-item__content__description">{data.description}</div>
          {!hasVolume && !hasDimensions && !hasWeight ? false : (
            <div className="vf-measurement-view-item__content__volume">

              <div className="vf-measurement-view-item__content__volume__block">
                <div className="vf-measurement-view-item__content__volume__block__header">
                  {strings.measurements.actualWeight}
                </div>
                <div className="vf-measurement-view-item__content__volume__block__text">
                  {hasWeight ? `${data.weight}${weightUnit}` : '-' }
                </div>
              </div>

              <div className="vf-measurement-view-item__content__volume__block">
                <div className="vf-measurement-view-item__content__volume__block__header">
                  {strings.measurements.volume}
                </div>
                <div className="vf-measurement-view-item__content__volume__block__text">
                  {!hasVolume && !hasDimensions ? '-'
                    : `${Utils.Helper.roundUpToTwoDecimalPlaces(volume)}${volumeUnit}`}
                  {hasDimensions ? (
                    <div className="vf-measurement-view-item__content__volume__block__text__subtext">
                      {`${renderedLength} x ${renderedWidth} x ${renderedHeight} ${dimensionUnit}`}
                    </div>
                  ) : false}
                </div>
              </div>

              <div className="vf-measurement-view-item__content__volume__block">
                <div className="vf-measurement-view-item__content__volume__block__header">
                  {strings.measurements.volumetricWeight}
                </div>
                <div className="vf-measurement-view-item__content__volume__block__text">
                  {(!hasVolume && !hasDimensions)
                    || Utils.Helper.isNullOrUndefined(account.shipping_factor)
                    ? '-' : `${Utils.Helper.calculateVolumetricWeight(
                      volume,
                      account.shipping_factor,
                      account.unit_system,
                    )}${weightUnit}`}
                  {(!hasVolume && !hasDimensions)
                    || Utils.Helper.isNullOrUndefined(account.shipping_factor) ? false
                    : (
                      <div className="vf-measurement-view-item__content__volume__block__text__subtext">
                        {`${strings.constants.by} ${account.shipping_factor} ${shippingFactorUnit}`}
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    );
  }
}

MeasurementViewItem.displayName = 'Measurement View Item';

MeasurementViewItem.propTypes = {
  account: PropTypes.shape({
    unit_system: PropTypes.string,
    shipping_factor: PropTypes.number,
  }).isRequired,
  data: PropTypes.shape({
    custom_item_id: PropTypes.string,
    quantity: PropTypes.number,
    quantity_unit: PropTypes.string,
    description: PropTypes.string,
    weight: PropTypes.number,
    volume_height: PropTypes.number,
    volume_length: PropTypes.number,
    volume_width: PropTypes.number,
    volume: PropTypes.number,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      by: PropTypes.string,
    }),
    measurements: PropTypes.shape({
      actualWeight: PropTypes.string,
      volume: PropTypes.string,
      volumetricWeight: PropTypes.string,
    }),
  }).isRequired,
  versadriveSetting: PropTypes.shape({
    delivery_job_scan_enabled: PropTypes.bool,
    delivery_task_scan_enabled: PropTypes.bool,
    pickup_job_scan_enabled: PropTypes.bool,
    pickup_task_scan_enabled: PropTypes.bool,
  }),
};

MeasurementViewItem.defaultProps = {
  onDelete: null,
  onEdit: null,
  versadriveSetting: {},
};

function mapStateToProps(state) {
  const { account, versadriveSetting } = state;
  return {
    account: account.account,
    versadriveSetting: versadriveSetting.versadriveSetting,
  };
}

export default connect(mapStateToProps)(translate('Task')(MeasurementViewItem));
